<template>
    <div>
        <nav-bar />
        <div class="main">
            <banner />
            <aboutus />
            <site-footer />
        </div>
    </div>
</template>

<script>
import NavBar from "../views/commons/NavBar";
import Banner from "../views/aboutusPage/Banner";
import aboutus from "../views/aboutusPage/aboutus";
import SiteFooter from "../views/index-five/SiteFooter";

export default {
    name: "DownloadPage",
    components: {
        NavBar,
        Banner,
        aboutus,
        SiteFooter,
    },
};
</script>

